import { render, staticRenderFns } from "./modebtns.vue?vue&type=template&id=f40d65aa&scoped=true&"
import script from "./modebtns.vue?vue&type=script&lang=js&"
export * from "./modebtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40d65aa",
  null
  
)

export default component.exports